<template>
    <div id="inbox-content">
        <div v-if="loading" class="loading"></div>
        <div v-else-if="answersData.submission">
            <div class="content-header">
                <h3>Form Submissions ID : {{ answersData.submission._id }}</h3>
            </div>
            <div class="content-header">
                <h2>Form Yanıtlanma Tarihi: {{ formattedDate }}</h2>
                <div class="header-actions">
                    <button
                        class="button read-btn"
                        @click="markAsRead"
                        v-if="notReadBtn"
                        :disabled="isUpdating"
                    >
                        <i class="fas fa-check"></i>
                        {{ isUpdating ? 'İşleniyor...' : 'Okundu Olarak işaretle' }}
                    </button>
                    <button
                        class="button read-btn"
                        @click="markAsArchive"
                        v-if="archiveBTN"
                        :disabled="isUpdating"
                    >
                        <i class="fas fa-check"></i>
                        {{ isUpdating ? "İşleniyor..." : "Arşivele" }}
                    </button>
                </div>
            </div>
            <div class="content-body">
                <div v-if="specialAnswer" class="info-item special-card">
                    <span class="label">Kullanıcı Adı: {{ specialAnswer.value[0].username }}</span>
                    <span class="label">Tam Ad: {{ specialAnswer.value[0].fullName }}</span>
                </div>
                <div class="info-item" v-for="(answer, index) in displayAnswers" :key="index">
                    <div class="answer-header">
                        <span class="label">{{ answer.fieldLabel }}</span>
                        <button
                            v-if="answer.fieldType !== 'fileUpload' && answer.fieldType !== 'signature' && hasUpdateResponsePermission"
                            class="edit-btn"
                            @click="toggleEditMode(answer._id)"
                            :disabled="isUpdating"
                        >
                            <i class="fas fa-edit"></i>
                            Düzenle
                        </button>
                    </div>

                    <div v-if="editModeAnswers[answer._id]" class="edit-mode">
                        <div class="edit-input-container">
                            <template v-if="['shortText', 'longText', 'email'].includes(answer.fieldType)">
                                <input
                                    v-if="answer.fieldType === 'shortText' || answer.fieldType === 'email'"
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    :type="answer.fieldType === 'email' ? 'email' : 'text'"
                                />
                                <textarea
                                    v-else
                                    v-model="editValues[answer._id]"
                                    class="edit-textarea"
                                    rows="3"
                                ></textarea>
                            </template>

                            <template v-else-if="['number', 'spinner'].includes(answer.fieldType)">
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="number"
                                />
                            </template>

                            <template v-else-if="answer.fieldType === 'phone'">
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="tel"
                                />
                            </template>

                            <template v-else-if="answer.fieldType === 'address'">
                                <div class="address-inputs">
                                    <input
                                        v-model="editValues[answer._id + '_address1']"
                                        class="edit-input"
                                        placeholder="Adres Satırı 1"
                                    />
                                    <input
                                        v-model="editValues[answer._id + '_address2']"
                                        class="edit-input"
                                        placeholder="Adres Satırı 2"
                                    />
                                    <input
                                        v-model="editValues[answer._id + '_district']"
                                        class="edit-input"
                                        placeholder="İlçe"
                                    />
                                    <input
                                        v-model="editValues[answer._id + '_city']"
                                        class="edit-input"
                                        placeholder="Şehir"
                                    />
                                    <input
                                        v-model="editValues[answer._id + '_postal']"
                                        class="edit-input"
                                        placeholder="Posta Kodu"
                                    />
                                </div>
                            </template>

                            <template v-else-if="answer.fieldType === 'fullName'">
                                <div class="fullname-inputs">
                                    <input
                                        v-model="editValues[answer._id + '_firstName']"
                                        class="edit-input"
                                        placeholder="Ad"
                                    />
                                    <input
                                        v-model="editValues[answer._id + '_lastName']"
                                        class="edit-input"
                                        placeholder="Soyad"
                                    />
                                </div>
                            </template>

                            <template v-else-if="answer.fieldType === 'starRating'">
                                <div class="star-rating-edit">
                                    <span
                                        v-for="star in 5"
                                        :key="star"
                                        class="star"
                                        :class="{ active: star <= editValues[answer._id] }"
                                        @click="editValues[answer._id] = star"
                                    >
                                        ★
                                    </span>
                                </div>
                            </template>

                            <template v-else-if="answer.fieldType === 'ratingScale'">
                                <div class="rating-scale-edit">
                                    <span
                                        v-for="rating in 5"
                                        :key="rating"
                                        class="rating-number"
                                        :class="{ active: rating === editValues[answer._id] }"
                                        @click="editValues[answer._id] = rating"
                                    >
                                        {{ rating }}
                                    </span>
                                </div>
                            </template>

                            <template v-else-if="['singleChoice', 'dropDownList'].includes(answer.fieldType)">
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="text"
                                    :placeholder="'Mevcut değer: ' + (answer.value && answer.value[0] ? answer.value[0] : '')"
                                />
                            </template>

                            <template v-else-if="answer.fieldType === 'multipleSelection'">
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="text"
                                    :placeholder="'Mevcut değer: ' + (answer.value && answer.value[0] ? answer.value[0] : '')"
                                />
                            </template>

                            <template v-else-if="answer.fieldType === 'datePicker'">
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="date"
                                />
                            </template>

                            <template v-else-if="answer.fieldType === 'hour'">
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="time"
                                />
                            </template>

                            <template v-else-if="answer.fieldType === 'signature'">
                                <div class="signature-edit-container">
                                    <div class="signature-current">
                                        <img
                                            v-if="answer.value"
                                            :src="answer.value"
                                            alt="Mevcut İmza"
                                            class="current-signature-image"
                                            @error="onSignatureImageError"
                                            @load="onSignatureImageLoad"
                                        />
                                        <div v-else class="no-current-signature">
                                            <i class="fas fa-signature"></i>
                                            Mevcut imza yok
                                        </div>
                                    </div>
                                    <div class="signature-edit-note">
                                        <i class="fas fa-info-circle"></i>
                                        İmza düzenlemesi visitor panelinden yapılabilir
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <input
                                    v-model="editValues[answer._id]"
                                    class="edit-input"
                                    type="text"
                                />
                            </template>
                        </div>

                        <div class="edit-actions">
                            <button
                                class="save-btn"
                                @click="saveAnswer(answer)"
                                :disabled="isUpdating"
                            >
                                <i class="fas fa-save"></i>
                                {{ isUpdating ? 'Kaydediliyor...' : 'Kaydet' }}
                            </button>
                            <button
                                class="cancel-btn"
                                @click="cancelEdit(answer._id)"
                                :disabled="isUpdating"
                            >
                                <i class="fas fa-times"></i>
                                İptal
                            </button>
                        </div>
                    </div>

                    <span v-else class="value">
                        <template v-if="answer.fieldType === 'fileUpload'">
                            <ul>
                                <viewer :options="{ inline: false }">
                                    <li v-for="(url, idx) in answer.value" :key="idx" class="file-list-item">
                                        <template v-if="url.endsWith('.pdf')">
                                            <div class="pdf-file" @click="openFile(url)">
                                                <svg width="24" height="24" viewBox="0 0 24 24">
                                                    <path
                                                        d="M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z" />
                                                </svg>
                                                PDF File
                                            </div>
                                        </template>
                                        <template v-else-if="url.endsWith('.svg')">
                                            <div class="svg-file" @click="openFile(url)">
                                                <svg width="24" height="24" viewBox="0 0 24 24">
                                                    <path
                                                        d="M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z" />
                                                </svg>
                                                SVG File
                                            </div>
                                        </template>
                                        <template v-else>
                                            <img :src="prependHttps(url)" :alt="'Image ' + (idx + 1)" />
                                        </template>
                                    </li>
                                </viewer>
                            </ul>
                        </template>
                        <template v-else-if="answer.fieldType === 'signature'">
                            <div class="signature-display">
                                <div v-if="answer.value" class="signature-image-container">
                                    <img
                                        :src="answer.value"
                                        alt="İmza"
                                        class="signature-image"
                                        @click="openSignatureModal(answer.value)"
                                        @error="onSignatureImageError"
                                        @load="onSignatureImageLoad"
                                    />
                                    <div class="signature-actions">
                                        <button
                                            class="signature-view-btn"
                                            @click="openSignatureModal(answer.value)"
                                            title="İmzayı büyüt"
                                        >
                                            <i class="fas fa-expand"></i>
                                            Büyüt
                                        </button>
                                        <button
                                            class="signature-download-btn"
                                            @click="downloadSignature(answer.value, answer.fieldLabel)"
                                            title="İmzayı indir"
                                        >
                                            <i class="fas fa-download"></i>
                                            İndir
                                        </button>
                                    </div>
                                </div>
                                <div v-else class="no-signature">
                                    <i class="fas fa-signature"></i>
                                    İmza bulunamadı
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            {{ getAnswerValue(answer) }}
                        </template>
                    </span>
                </div>
            </div>
        </div>
        <div v-else class="no-data">
            {{ $t("form.noSubmissionData") }}
        </div>

        <!-- Signature Modal -->
        <div v-if="signatureModalVisible" class="signature-modal-overlay" @click="closeSignatureModal">
            <div class="signature-modal" @click.stop>
                <div class="signature-modal-header">
                    <h3>İmza Görüntüle</h3>
                    <button class="close-btn" @click="closeSignatureModal">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="signature-modal-body">
                    <img :src="selectedSignature" alt="İmza" class="signature-modal-image" />
                </div>
                <div class="signature-modal-footer">
                    <button
                        class="download-btn"
                        @click="downloadSignature(selectedSignature, 'Imza')"
                    >
                        <i class="fas fa-download"></i>
                        İndir
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment/moment";
import _ from "lodash";

export default {
    name: "InboxContents",
    props: {
        submissionId: {
            type: String,
            required: true,
        },
        notReadBtn: {
            type: Boolean,
            required: true,
        },
        archiveBTN: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            answersData: {
                submission: null,
                answers: []
            },
            isModalVisible: false,
            selectedImage: "",
            loading: true,
            isUpdating: false,
            editModeAnswers: {},
            editValues: {},
            originalValues: {},
            signatureModalVisible: false,
            selectedSignature: "",
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
        hasUpdateResponsePermission() {
            // Admin kullanıcılar her zaman yetkili
            if (this.adminUser) return true;
            
            if (!this.user) return false;
            
            // Root kullanıcılar her zaman yetkili
            const isRoot = _.get(this.user, "role.isRoot", false);
            if (isRoot) return true;
            
            // Normal kullanıcılar için permission kontrolü
            const permissions = _.get(this.user, "role.permissions", []).map((x) => x.name);
            return permissions.includes("form.updateResponse");
        },
        formattedDate() {
            if (this.answersData.submission && this.answersData.submission.createdAt) {
                return moment(this.answersData.submission.createdAt).format("DD MMMM YYYY HH:mm");
            }
            return "";
        },
        specialAnswer() {
            return (this.answersData.answers || []).find(answer =>
                answer.value &&
                answer.value[0] &&
                answer.value[0].username &&
                answer.value[0].fullName
            );
        },
        filteredAnswers() {
            const answers = this.answersData.answers || [];
            return answers
                .filter(answer => !(
                    answer.value &&
                    answer.value[0] &&
                    answer.value[0].username &&
                    answer.value[0].fullName
                ))
                .sort((a, b) => a.order - b.order);
        },
        displayAnswers() {
            return this.filteredAnswers
                .filter(answer => answer.fieldLabel)
                .filter(answer => answer.fieldType !== 'pagebreak') // PageBreak cevaplarını filtrele
                .filter(answer => answer.fieldType !== 'captcha'); // Captcha cevaplarını filtrele
        },
    },
    watch: {
        submissionId: {
            immediate: true,
            handler() {
                this.getFormAnswers();
            },
        },
        answersData: {
            immediate: true,
            handler() {
                this.loading = false;
            },
        },
    },
    mounted() {
        this.getFormAnswers();
    },
    methods: {
        ...mapActions({
            updateFormStatus: "forms/updateFormStatus",
            updateFormAnswers: "forms/updateFormAnswers",
            getFormAnswersBySubmissionId: "forms/getFormAnswersBySubmissionId",
        }),
        async getFormAnswers() {
            try {
                this.loading = true;
                const data = await this.getFormAnswersBySubmissionId({
                    siteId: this.site._id,
                    submissionId: this.submissionId,
                });
                if (data) {
                    this.answersData = data;
                }
            } catch (error) {
                console.error("Error fetching form answers:", error);
            } finally {
                this.loading = false;
            }
        },
        getAnswerValue(answer) {
            if (!answer || answer.value == null) {
                return "";
            }
            const value = answer.value;

            // Debug log for signature
            if (answer.fieldType === 'signature') {
                console.log('🔴 Signature answer data:', {
                    fieldType: answer.fieldType,
                    fieldLabel: answer.fieldLabel,
                    value: value,
                    valueType: typeof value,
                    base64Preview: value ? value.substring(0, 50) + '...' : 'No base64',
                    isValid: this.isValidSignature(value)
                });
            }

            switch (answer.fieldType) {
                case "fullName":
                    return value.join(" ");
                case "email":
                case "shortText":
                case "longText":
                case "number":
                case "spinner":
                    return value[0];
                case "phone":
                    return value[0];
                case "address":
                    return value.join(", ");
                case "datePicker":
                case "hour":
                    return value.join(", ");
                case "starRating":
                    return this.renderStars(parseInt(value[0]));
                case "ratingScale":
                    return value.join(", ");
                case "multipleSelection":
                case "singleChoice":
                case "dropDownList":
                    return value.join(", ");
                case "fileUpload":
                    return "";
                case "signature":
                    return value ? "İmza mevcut" : "İmza yok";
                case "captcha":
                    return value && value[0] ? "Doğrulandı" : "Doğrulanmadı";
                default:
                    return value.join(", ");
            }
        },
        prependHttps(url) {
            // Eğer URL bir asset object ise
            if (typeof url === 'object' && url.path) {
                return url.v2Format && url.cdnUrl
                    ? url.cdnUrl
                    : `https://static.supsis.live/${url.path + url._id}.${url.ext}`;
            }

            // Eğer URL string ise
            if (typeof url === 'string') {
                if (url.startsWith("http")) {
                    return url;
                }
                // Eğer static.supsis.live ile başlıyorsa tam URL'i oluştur
                if (url.includes('static.supsis.live') || url.startsWith('/')) {
                    return url.startsWith('http') ? url : `https://${url}`;
                }
                return `https://${url}`;
            }

            return url;
        },
        openFile(url) {
            window.open(this.prependHttps(url), "_blank");
        },
        openModal(url) {
            this.selectedImage = url;
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
            this.selectedImage = "";
        },
        renderStars(rating) {
            return "★".repeat(rating) + "☆".repeat(5 - rating);
        },
        async markAsRead() {
            if (this.answersData.submission) {
                try {
                    this.isUpdating = true;
                    const currentSubmission = { ...this.answersData.submission };
                    const currentStatus = "read";

                    this.$emit("mark-as-read", {
                        submissionId: currentSubmission._id,
                        status: currentStatus,
                        previousStatus: this.answersData.submission.status
                    });

                    await this.updateFormStatus({
                        siteId: this.site._id,
                        submissionId: currentSubmission._id,
                        newStatus: currentStatus
                    });

                } catch (error) {
                    console.error("Error marking as read:", error);
                    this.$emit("mark-as-read-error", {
                        submissionId: this.answersData.submission._id,
                        error: error
                    });
                } finally {
                    this.isUpdating = false;
                }
            }
        },
        async markAsArchive() {
            if (this.answersData.submission) {
                try {
                    this.isUpdating = true;
                    const currentSubmission = { ...this.answersData.submission };
                    const currentStatus = "archive";

                    this.$emit("mark-as-read", {
                        submissionId: currentSubmission._id,
                        status: currentStatus,
                        previousStatus: this.answersData.submission.status,
                    });

                    await this.updateFormStatus({
                        siteId: this.site._id,
                        submissionId: currentSubmission._id,
                        newStatus: currentStatus,
                    });

                } catch (error) {
                    console.error("Error marking as read:", error);
                    this.$emit("mark-as-read-error", {
                        submissionId: this.answersData.submission._id,
                        error: error,
                    });
                } finally {
                    this.isUpdating = false;
                }
            }
        },
        toggleEditMode(answerId) {
            Object.keys(this.editModeAnswers).forEach(id => {
                this.$set(this.editModeAnswers, id, false);
            });

            this.$set(this.editModeAnswers, answerId, true);
            this.initializeEditValues(answerId);
        },
        initializeEditValues(answerId) {
            const answer = this.displayAnswers.find(a => a._id === answerId);
            if (!answer) return;

            let initialValue = "";

            switch (answer.fieldType) {
                case "fullName":
                    const nameParts = answer.value || ["", ""];
                    this.$set(this.editValues, answerId + "_firstName", nameParts[0] || "");
                    this.$set(this.editValues, answerId + "_lastName", nameParts[1] || "");
                    this.$set(this.originalValues, answerId + "_firstName", nameParts[0] || "");
                    this.$set(this.originalValues, answerId + "_lastName", nameParts[1] || "");
                    return;
                case "address":
                    const addressParts = answer.value || ["", "", "", "", ""];
                    this.$set(this.editValues, answerId + "_address1", addressParts[0] || "");
                    this.$set(this.editValues, answerId + "_address2", addressParts[1] || "");
                    this.$set(this.editValues, answerId + "_district", addressParts[2] || "");
                    this.$set(this.editValues, answerId + "_city", addressParts[3] || "");
                    this.$set(this.editValues, answerId + "_postal", addressParts[4] || "");
                    this.$set(this.originalValues, answerId + "_address1", addressParts[0] || "");
                    this.$set(this.originalValues, answerId + "_address2", addressParts[1] || "");
                    this.$set(this.originalValues, answerId + "_district", addressParts[2] || "");
                    this.$set(this.originalValues, answerId + "_city", addressParts[3] || "");
                    this.$set(this.originalValues, answerId + "_postal", addressParts[4] || "");
                    return;
                case "multipleSelection":
                case "singleChoice":
                case "dropDownList":
                    initialValue = Array.isArray(answer.value) && answer.value.length > 0 ? answer.value[0] : "";
                    break;
                case "starRating":
                    initialValue = parseInt(answer.value[0]) || 1;
                    break;
                case "ratingScale":
                    initialValue = parseInt(answer.value[0]) || 1;
                    break;
                case "datePicker":
                    if (answer.value && answer.value[0]) {
                        const date = new Date(answer.value[0]);
                        initialValue = date.toISOString().split('T')[0];
                    }
                    break;
                case "hour":
                    initialValue = answer.value && answer.value[0] ? answer.value[0] : "";
                    break;
                default:
                    initialValue = Array.isArray(answer.value) && answer.value.length > 0 ? answer.value[0] : "";
            }

            this.$set(this.editValues, answerId, initialValue);
            this.$set(this.originalValues, answerId, initialValue);
        },
        cancelEdit(answerId) {
            this.$set(this.editModeAnswers, answerId, false);
            const answer = this.displayAnswers.find(a => a._id === answerId);
            if (answer && answer.fieldType === "fullName") {
                this.$set(this.editValues, answerId + "_firstName", this.originalValues[answerId + "_firstName"]);
                this.$set(this.editValues, answerId + "_lastName", this.originalValues[answerId + "_lastName"]);
            } else if (answer && answer.fieldType === "address") {
                this.$set(this.editValues, answerId + "_address1", this.originalValues[answerId + "_address1"]);
                this.$set(this.editValues, answerId + "_address2", this.originalValues[answerId + "_address2"]);
                this.$set(this.editValues, answerId + "_district", this.originalValues[answerId + "_district"]);
                this.$set(this.editValues, answerId + "_city", this.originalValues[answerId + "_city"]);
                this.$set(this.editValues, answerId + "_postal", this.originalValues[answerId + "_postal"]);
            } else {
                this.$set(this.editValues, answerId, this.originalValues[answerId]);
            }
        },
        async saveAnswer(answer) {
            try {
                this.isUpdating = true;

                let newValue = [];

                switch (answer.fieldType) {
                    case "fullName":
                        const firstName = this.editValues[answer._id + "_firstName"] || "";
                        const lastName = this.editValues[answer._id + "_lastName"] || "";
                        newValue = [firstName, lastName];
                        break;
                    case "address":
                        const address1 = this.editValues[answer._id + "_address1"] || "";
                        const address2 = this.editValues[answer._id + "_address2"] || "";
                        const district = this.editValues[answer._id + "_district"] || "";
                        const city = this.editValues[answer._id + "_city"] || "";
                        const postal = this.editValues[answer._id + "_postal"] || "";
                        newValue = [address1, address2, district, city, postal];
                        break;
                    case "multipleSelection":
                    case "singleChoice":
                    case "dropDownList":
                        newValue = [this.editValues[answer._id] || ""];
                        break;
                    case "starRating":
                    case "ratingScale":
                        newValue = [this.editValues[answer._id].toString()];
                        break;
                    case "datePicker":
                    case "hour":
                        newValue = [this.editValues[answer._id]];
                        break;
                    case "signature":
                        newValue = [this.editValues[answer._id] || ""];
                        break;
                    case "captcha":
                        newValue = [this.editValues[answer._id] || ""];
                        break;
                    default:
                        newValue = [this.editValues[answer._id]];
                }

                const answersData = [{
                    answerId: answer._id,
                    value: newValue
                }];

                await this.updateFormAnswers({
                    siteId: this.site._id,
                    submissionId: this.submissionId,
                    answersData: answersData
                });

                this.$set(this.editModeAnswers, answer._id, false);

                await this.getFormAnswers();

                this.$message.success("Cevap başarıyla güncellendi");

            } catch (error) {
                console.error("Error updating answer:", error);
                this.$message.error("Cevap güncellenirken hata oluştu");
            } finally {
                this.isUpdating = false;
            }
        },
        openSignatureModal(signatureData) {
            this.selectedSignature = signatureData;
            this.signatureModalVisible = true;
        },
        closeSignatureModal() {
            this.signatureModalVisible = false;
            this.selectedSignature = "";
        },
        downloadSignature(signatureData, fieldLabel) {
            try {
                // Base64 imzayı indirme
                const link = document.createElement('a');
                link.href = signatureData;
                link.download = `${fieldLabel || 'Imza'}_${new Date().toISOString().split('T')[0]}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                console.log('🔴 Signature downloaded:', {
                    fieldLabel,
                    dataLength: signatureData.length
                });
            } catch (error) {
                console.error('Error downloading signature:', error);
                this.$message.error('İmza indirilemedi');
            }
        },
        isValidSignature(signatureData) {
            // Base64 signature validation
            if (!signatureData || typeof signatureData !== 'string') {
                return false;
            }

            // Check if it's a valid base64 data URL
            const base64Pattern = /^data:image\/(png|jpeg|jpg|gif);base64,/;
            if (!base64Pattern.test(signatureData)) {
                console.warn('🔴 Invalid signature format:', signatureData.substring(0, 50));
                return false;
            }

            // Check if base64 data is not empty
            const base64Data = signatureData.split(',')[1];
            if (!base64Data || base64Data.length < 100) {
                console.warn('🔴 Signature data too short:', base64Data?.length);
                return false;
            }

            return true;
        },
        onSignatureImageError(event) {
            console.error('🔴 Signature image load error:', {
                src: event.target.src.substring(0, 50),
                error: event
            });
        },
        onSignatureImageLoad(event) {
            console.log('🔴 Signature image loaded successfully:', {
                width: event.target.naturalWidth,
                height: event.target.naturalHeight
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#inbox-content {
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    position: relative;

    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 48px;
        height: 48px;
        border: 3px solid #e2e8f0;
        border-radius: 50%;
        border-top-color: #0288d1;
        animation: spin 1s linear infinite;
        z-index: 10;
    }

    .content-header {
        padding: 1.5rem;
        background: linear-gradient(to right, #f8fafc, #ffffff);
        border-bottom: 1px solid #e2e8f0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        flex-shrink: 0;

        h3 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1e293b;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 0.75rem;

            .anticon {
                font-size: 1.5rem;
                color: #0288d1;
            }
        }

        .header-actions {
            display: flex;
            gap: 0.75rem;

            button {
                padding: 0.5rem 1rem;
                border-radius: 8px;
                font-weight: 500;
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                border: 1px solid transparent;

                &.read-btn {
                    background-color: #e3f2fd;
                    color: #0288d1;

                    &:hover {
                        background-color: #bbdefb;
                        transform: translateY(-1px);
                    }

                    .anticon {
                        color: #0288d1;
                    }
                }

                &.archive-btn {
                    background-color: #f1f5f9;
                    color: #64748b;

                    &:hover {
                        background-color: #e2e8f0;
                        color: #475569;
                        transform: translateY(-1px);
                    }

                    .anticon {
                        color: inherit;
                    }
                }

                .anticon {
                    font-size: 1rem;
                }
            }
        }
    }

    .content-body {
        flex: 1;
        padding: 1.5rem;
        overflow-y: auto;
        overflow-x: hidden;

        .info-item {
            background-color: #ffffff;
            border-radius: 12px;
            padding: 1.25rem;
            margin-bottom: 1rem;
            border: 1px solid #e2e8f0;
            transition: all 0.3s ease;

            &:hover {
                border-color: #90caf9;
                box-shadow: 0 4px 12px rgba(2, 136, 209, 0.08);
            }

            &.special-card {
                background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
                border-color: #90caf9;

                .label {
                    color: #0288d1;
                }
            }

            .answer-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 0.75rem;

                .label {
                    font-weight: 600;
                    color: #475569;
                    font-size: 0.9rem;
                    margin: 0;
                }

                .edit-btn {
                    padding: 0.25rem 0.75rem;
                    background-color: #f8fafc;
                    color: #64748b;
                    border: 1px solid #e2e8f0;
                    border-radius: 6px;
                    font-size: 0.75rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 0.25rem;

                    &:hover {
                        background-color: #e3f2fd;
                        color: #0288d1;
                        border-color: #90caf9;
                    }

                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }

                    i {
                        font-size: 0.75rem;
                    }
                }
            }

            .edit-mode {
                margin-bottom: 0.75rem;

                .edit-input-container {
                    margin-bottom: 0.75rem;

                    .edit-input, .edit-textarea, .edit-select {
                        width: 100%;
                        padding: 0.5rem;
                        border: 1px solid #d1d5db;
                        border-radius: 6px;
                        font-size: 0.875rem;
                        transition: all 0.3s ease;

                        &:focus {
                            outline: none;
                            border-color: #0288d1;
                            box-shadow: 0 0 0 3px rgba(2, 136, 209, 0.1);
                        }
                    }

                    .edit-textarea {
                        resize: vertical;
                        min-height: 80px;
                    }

                    .fullname-inputs {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 0.5rem;
                    }

                    .address-inputs {
                        display: grid;
                        grid-template-columns: 1fr;
                        gap: 0.5rem;

                        .edit-input:nth-child(3),
                        .edit-input:nth-child(4) {
                            grid-column: 1 / span 1;
                        }

                        @media (min-width: 768px) {
                            grid-template-columns: 1fr 1fr;

                            .edit-input:nth-child(1) {
                                grid-column: 1 / span 2;
                            }

                            .edit-input:nth-child(2) {
                                grid-column: 1 / span 2;
                            }
                        }
                    }

                    .star-rating-edit {
                        display: flex;
                        gap: 0.25rem;

                        .star {
                            font-size: 1.5rem;
                            color: #d1d5db;
                            cursor: pointer;
                            transition: color 0.2s ease;

                            &.active {
                                color: #fbbf24;
                            }

                            &:hover {
                                color: #f59e0b;
                            }
                        }
                    }

                    .rating-scale-edit {
                        display: flex;
                        gap: 0.5rem;
                        flex-wrap: wrap;

                        .rating-number {
                            min-width: 30px;
                            height: 30px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid #d1d5db;
                            border-radius: 6px;
                            cursor: pointer;
                            transition: all 0.2s ease;
                            font-weight: 500;

                            &.active {
                                background-color: #0288d1;
                                color: white;
                                border-color: #0288d1;
                            }

                            &:hover {
                                border-color: #0288d1;
                                background-color: #e3f2fd;
                            }
                        }
                    }

                    .checkbox-group {
                        .checkbox-label {
                            display: flex;
                            align-items: center;
                            gap: 0.5rem;
                            margin-bottom: 0.5rem;
                            cursor: pointer;
                            font-size: 0.875rem;

                            input[type="checkbox"] {
                                width: auto;
                                margin: 0;
                            }

                            &:hover {
                                color: #0288d1;
                            }
                        }
                    }

                    /* Signature Edit Styles */
                    .signature-edit-container {
                        .signature-current {
                            margin-bottom: 0.75rem;
                            text-align: center;

                            .current-signature-image {
                                max-width: 250px;
                                max-height: 150px;
                                width: auto;
                                height: auto;
                                border-radius: 6px;
                                border: 1px solid #e2e8f0;
                                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                                background: #ffffff;
                                display: block;
                                object-fit: contain;
                            }

                            .no-current-signature {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                gap: 0.5rem;
                                padding: 2rem;
                                background: #f8fafc;
                                border: 1px dashed #cbd5e1;
                                border-radius: 6px;
                                color: #64748b;
                                font-style: italic;

                                i {
                                    font-size: 1.5rem;
                                    color: #94a3b8;
                                }
                            }
                        }

                        .signature-edit-note {
                            display: flex;
                            align-items: center;
                            gap: 0.5rem;
                            padding: 0.75rem;
                            background: #fef3cd;
                            border: 1px solid #fde047;
                            border-radius: 6px;
                            color: #a16207;
                            font-size: 0.875rem;

                            i {
                                font-size: 1rem;
                                color: #d97706;
                            }
                        }
                    }
                }

                .edit-actions {
                    display: flex;
                    gap: 0.5rem;

                    .save-btn, .cancel-btn {
                        padding: 0.5rem 1rem;
                        border-radius: 6px;
                        font-size: 0.875rem;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        border: 1px solid transparent;

                        &:disabled {
                            opacity: 0.5;
                            cursor: not-allowed;
                        }

                        i {
                            font-size: 0.875rem;
                        }
                    }

                    .save-btn {
                        background-color: #0288d1;
                        color: white;

                        &:hover:not(:disabled) {
                            background-color: #0277bd;
                            transform: translateY(-1px);
                        }
                    }

                    .cancel-btn {
                        background-color: #f1f5f9;
                        color: #64748b;
                        border-color: #e2e8f0;

                        &:hover:not(:disabled) {
                            background-color: #e2e8f0;
                            color: #475569;
                        }
                    }
                }
            }

            .label {
                font-weight: 600;
                color: #475569;
                margin-bottom: 0.5rem;
                font-size: 0.9rem;
            }

            .value {
                color: #1e293b;
                line-height: 1.6;
                font-size: 0.95rem;

                ul {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
                    gap: 1rem;
                    padding: 0;
                    list-style: none;
                    margin: 0.5rem 0;

                    .file-list-item {
                        .pdf-file, .svg-file {
                            display: flex;
                            align-items: center;
                            padding: 0.75rem;
                            background: #f8fafc;
                            border-radius: 8px;
                            color: #0288d1;
                            font-size: 0.875rem;
                            transition: all 0.3s ease;
                            border: 1px solid #e2e8f0;
                            cursor: pointer;

                            svg {
                                margin-right: 0.5rem;
                                width: 20px;
                                height: 20px;
                                fill: currentColor;
                            }

                            &:hover {
                                background: #e3f2fd;
                                transform: translateY(-2px);
                                border-color: #90caf9;
                            }
                        }

                        img {
                            width: 100%;
                            height: 120px;
                            object-fit: cover;
                            border-radius: 8px;
                            transition: all 0.3s ease;
                            border: 1px solid #e2e8f0;
                            cursor: pointer;
                            max-width: 200px;
                            max-height: 150px;

                            &:hover {
                                transform: scale(1.05);
                                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                                border-color: #90caf9;
                            }
                        }
                    }
                }
            }

            /* Signature Display Styles */
            .signature-display {
                .signature-image-container {
                    position: relative;
                    display: inline-block;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    background: #ffffff;
                    border: 1px solid #e2e8f0;

                    .signature-image {
                        display: block;
                        max-width: 300px;
                        max-height: 200px;
                        width: auto;
                        height: auto;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        background: #ffffff;
                        border: 1px solid #e2e8f0;
                        border-radius: 6px;
                        object-fit: contain;

                        &:hover {
                            transform: scale(1.02);
                            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                        }
                    }

                    .signature-actions {
                        position: absolute;
                        top: 0.5rem;
                        right: 0.5rem;
                        display: flex;
                        gap: 0.25rem;
                        opacity: 0;
                        transition: opacity 0.3s ease;
                    }

                    &:hover .signature-actions {
                        opacity: 1;
                    }

                    .signature-view-btn,
                    .signature-download-btn {
                        padding: 0.375rem;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                        font-size: 0.75rem;
                        font-weight: 500;
                        transition: all 0.2s ease;
                        display: flex;
                        align-items: center;
                        gap: 0.25rem;

                        i {
                            font-size: 0.75rem;
                        }
                    }

                    .signature-view-btn {
                        background: rgba(2, 136, 209, 0.9);
                        color: white;

                        &:hover {
                            background: rgba(2, 136, 209, 1);
                            transform: translateY(-1px);
                        }
                    }

                    .signature-download-btn {
                        background: rgba(34, 197, 94, 0.9);
                        color: white;

                        &:hover {
                            background: rgba(34, 197, 94, 1);
                            transform: translateY(-1px);
                        }
                    }
                }

                .no-signature {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 1rem;
                    background: #f8fafc;
                    border: 1px dashed #cbd5e1;
                    border-radius: 8px;
                    color: #64748b;
                    font-style: italic;

                    i {
                        font-size: 1.25rem;
                        color: #94a3b8;
                    }
                }
            }
        }
    }

    /* Signature Modal Styles */
    .signature-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.75);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        animation: fadeIn 0.3s ease;
    }

    .signature-modal {
        background: white;
        border-radius: 12px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        max-width: 90vw;
        max-height: 90vh;
        overflow: hidden;
        animation: slideUp 0.3s ease;

        .signature-modal-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1.5rem;
            background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
            color: white;

            h3 {
                margin: 0;
                font-size: 1.25rem;
                font-weight: 600;
            }

            .close-btn {
                background: rgba(255, 255, 255, 0.2);
                border: none;
                border-radius: 50%;
                width: 2rem;
                height: 2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                color: white;
                transition: all 0.2s ease;

                &:hover {
                    background: rgba(255, 255, 255, 0.3);
                    transform: scale(1.1);
                }

                i {
                    font-size: 1rem;
                }
            }
        }

        .signature-modal-body {
            padding: 2rem;
            text-align: center;
            background: #ffffff;

            .signature-modal-image {
                max-width: 100%;
                max-height: 60vh;
                min-width: 200px;
                min-height: 100px;
                width: auto;
                height: auto;
                border-radius: 8px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                border: 1px solid #e2e8f0;
                object-fit: contain;
                background: #ffffff;

                // Loading state
                &:not([src]) {
                    background: #f8fafc;
                    border: 2px dashed #cbd5e1;

                    &::before {
                        content: 'İmza yükleniyor...';
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 200px;
                        color: #64748b;
                        font-style: italic;
                    }
                }
            }
        }

        .signature-modal-footer {
            padding: 1rem 1.5rem;
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
            display: flex;
            justify-content: center;

            .download-btn {
                padding: 0.75rem 1.5rem;
                background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
                color: white;
                border: none;
                border-radius: 8px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.5rem;

                &:hover {
                    background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
                }

                i {
                    font-size: 1rem;
                }
            }
        }
    }
}

    .no-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 2rem;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);

        .anticon {
            font-size: 3rem;
            color: #94a3b8;
            margin-bottom: 1rem;
        }

        p {
            color: #64748b;
            font-size: 1rem;
            text-align: center;
            margin: 0;
        }
    }

    .no-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 2rem;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);

        .anticon {
            font-size: 3rem;
            color: #94a3b8;
            margin-bottom: 1rem;
        }

        p {
            color: #64748b;
            font-size: 1rem;
            text-align: center;
            margin: 0;
        }
    }

@keyframes spin {
    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

:deep(.viewer-container) {
    background-color: rgba(0, 0, 0, 0.85);

    .viewer-footer {
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(10px);
    }

    .viewer-toolbar {
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(10px);

        & > ul {
            & > li {
                background-color: transparent;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                }

                &.viewer-large {
                    color: white;
                }

                &.viewer-one-to-one {
                    color: white;
                }

                &.viewer-reset {
                    color: white;
                }

                &.viewer-prev {
                    color: white;
                }

                &.viewer-play {
                    color: white;
                }

                &.viewer-next {
                    color: white;
                }

                &.viewer-rotate-left {
                    color: white;
                }

                &.viewer-rotate-right {
                    color: white;
                }

                &.viewer-flip-horizontal {
                    color: white;
                }

                &.viewer-flip-vertical {
                    color: white;
                }
            }
        }
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
</style>
